import { useQuery } from "@tanstack/react-query";
import { Fragment, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import { PiWarningFill } from "react-icons/pi";
import { getMethod } from "../../../../function/helper";
import style from "./CompanyValidateModal.module.css";

function CompanyValidateModal({
  onClose,
  onSubmit,
  cityId,
  isLoading,
  setIsLoading,
}) {
  const { isFetching, data } = useQuery({
    queryKey: ["CompanyValidateModal" + cityId],
    queryFn: () =>
      getMethod("/address/v1/city/company-validate?cityId=" + cityId).then(
        res => {
          if (res && res.status === 200) {
            if (
              res.result.post === false ||
              res.result.chapar === false ||
              res.result.mahex === false ||
              res.result.tipax === false ||
              res.result.dekapost === false ||
              res.result.parsiPost === false ||
              res.result.avaexpress === false
            ) {
              return res.result;
            }
          }

          onSubmit();
          return null;
        }
      ),

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    placeholderData: null,
  });

  useEffect(() => {
    setIsLoading(isFetching);
  }, [isFetching]);

  if (isFetching || !data) {
    return <Fragment></Fragment>;
  }

  return (
    <Modal
      show
      centered
      size="lg"
      className={style.zIndexHigher + " " + style.modal}
      backdropClassName={style.zIndexHigh}
    >
      <ModalHeader className="bg-white">
        <div className={"d-flex align-items-center " + style.icon}>
          <PiWarningFill />
          <h3 className="font-style-none mb-0 me-3">هشدار</h3>
        </div>
      </ModalHeader>

      <ModalBody className="bg-white">
        <div className={style.content}>
          <p className="mb-3">کاربر محترم:</p>
          {data.mahex === false && (
            <p className="mb-3">
              شهر انتخابی شما در سرویس <strong>ماهکس</strong> فعال نیست
            </p>
          )}
          {data.chapar === false && (
            <p className="mb-3">
              شهر انتخابی شما در سرویس <strong>چاپار</strong> فعال نیست
            </p>
          )}
          {data.tipax === false && (
            <p className="mb-3">
              شهر انتخابی شما در سرویس <strong>تیپاکس</strong> فعال نیست
            </p>
          )}
          {data.dekapost === false && (
            <p className="mb-3">
              <span>شهر انتخابی شما در سرویس </span>
              <strong>دکاپست</strong>
              <span> فعال نیست</span>
            </p>
          )}
          {data.parsiPost === false && (
            <p className="mb-3">
              <span>شهر انتخابی شما در سرویس </span>
              <strong>پارسی پست</strong>
              <span> فعال نیست</span>
            </p>
          )}
          {data.avaexpress === false && (
            <p className="mb-3">
              <span>شهر انتخابی شما در سرویس </span>
              <strong>آوا اکسپرس</strong>
              <span> فعال نیست</span>
            </p>
          )}
          {data.post === false && (
            <div className="border border-2 rounded-1 p-2">
              <p className="mb-2">
                شهر انتخابی شما در سرویس <strong>پست ملی</strong> فعال نیست
              </p>

              <div className="d-flex flex-column justify-content-center">
                <p className="mb-1 fw-bold">
                  <FaCircle color="green" />
                  <span className="me-2">
                    پست ملی تمامی نقاط کشور را پوشش می‌دهد.
                  </span>
                </p>
                <p className="mb-1">
                  <FaCircle color="green" />
                  <span className="me-2">
                    فقط کافی است بجای شهرستان مورد نظرتان ، شهر مرکز استان را
                    انتخاب کنید و در قسمت <strong>آدرس </strong> نام شهرستان
                    مقصد به همراه آدرس کامل را وارد نمایید.
                  </span>
                </p>
                <p className="mb-0"></p>
              </div>
              <p className="mb-3"></p>
            </div>
          )}
        </div>
      </ModalBody>

      <ModalFooter className="bg-white">
        <button
          className="btn btn-primary"
          onClick={onClose}
          disabled={isLoading === true}
        >
          ویرایش شهر
        </button>

        <button
          className="btn btn-danger d-flex align-items-center"
          onClick={onSubmit}
          disabled={isLoading === true}
        >
          {isLoading === true ? (
            <div className="d-flex align-items-center">
              <Spinner
                style={{
                  width: "20px",
                  height: "20px",
                  fontSize: "0.8rem",
                }}
              />
              <span className="me-1"> در حال ثبت</span>
            </div>
          ) : (
            <span>ادامه</span>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default CompanyValidateModal;
